<template>
  <draggable
      class="list-group"
      tag="div"
      v-model="dataFields"
      v-bind="dragOptions"
      @start="drag = true"
      @end="drag = false"
      handle=".field-handle"
      :group="group"
      @change="onDrag"
  >
    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
      <div v-for="field in dataFields" :key="field.id" class="ma-3 mx-5 pa-3 py-0">
        <v-row class="v-facet list-group-item pt-0 pb-0" align="center">
          <v-col cols="1">
            <v-btn class="field-handle" icon>
              <i class="fa fa-arrows-v"></i>
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-checkbox
                        :label="field.field.translations[locale].label" v-model="field.isEnabled"
                        @change="fieldCheckboxEnabled(field, $event)"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-switch :label="Translator('admin.notice_collection.facets.label')" @change="fieldSwitchLabel(field, $event)"
                      v-model="field.showLabel"></v-switch>
          </v-col>
          <v-col cols="2" v-if="dataLevel == 1">
            <v-select
              v-model="field.fontClass"
              :label="Translator('admin.notice_collection.facets.font_size')"
              @change="zoneSwitchFont(field, $event)"
              item-text="label"
              item-value="value"
              :outlined="true"
              :dense="true"
              :items="fontThemes"></v-select>
          </v-col>
          <v-col cols="1" :offset="dataLevel == 1 ? '1': '3'">
            <v-menu
              :close-on-content-click="false"
              :nudge-width="200"
              offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab depressed small
                  v-bind="attrs"
                  v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-list>
                  <v-list-item>
                    <v-list-item-action>
                      <v-switch
                        v-model="field.bulletPoint"
                        @change="zoneSwitchBulletPoint(field, $event)"></v-switch>
                    </v-list-item-action>
                    <v-list-item-title>{{ Translator('admin.notice_collection.facets.bullet_point') }}</v-list-item-title>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list>
                  <v-list-item>
                    <v-list-item-action>
                      <v-switch
                        v-model="field.topSpacing"
                        @change="zoneSwitchTopSpacing(field, $event)"></v-switch>
                    </v-list-item-action>
                    <v-list-item-title>{{ Translator('admin.notice_collection.facets.top_spacing') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-action>
                      <v-switch
                        v-model="field.bottomSpacing"
                        @change="zoneSwitchBottomSpacing(field, $event)"></v-switch>
                    </v-list-item-action>
                    <v-list-item-title>{{ Translator('admin.notice_collection.facets.bottom_spacing') }}</v-list-item-title>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list>
                  <v-list-item>
                    <v-list-item-action>
                      <v-switch
                        v-model="field.mergeContent"
                        @change="zoneSwitchMergeContent(field, $event)"></v-switch>
                    </v-list-item-action>
                    <v-list-item-title>{{ Translator('admin.notice_collection.facets.merge_content') }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </v-col>
          <v-col cols="1" v-if="field.children.length > 0">
            <v-btn
                icon
                @click="openClose(field.id)">
              <v-icon>{{ isOpen(field.id) ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <Field v-if="field.children.length > 0 && isOpen(field.id)" :fields="field.children" :group="field.id + '_field'" :level="2"></Field>
      </div>
    </transition-group>
  </draggable>
</template>
<style scoped lang="scss">
  .v-input {
    &.v-input--selection-controls {
      margin-top: 0;
    }
  }
  .list-group {
    background-color: #eee;
    margin-bottom: 0;
    padding-bottom: rem(10);
    .list-group-item {
      border-top: 0;
    }
  }
  .v-divider {
    margin-top: rem(1);
    margin-bottom: rem(1);
  }
  .v-facet {
    .v-messages {
        display: none !important;
    }
    .v-label {
        font-weight: normal !important;
        font-size: 14px !important;
        margin-bottom: 0 !important;
    }
  }
</style>
<script>
import draggable from 'vuedraggable'
import ZoneProfileInstanceAPI from '@/api/zoneProfileInstance'
import PositionsAPI from '@/api/positions'
import helper from '@/helper'

export default {
  name: 'Field',
  components: {
    draggable
  },
  props: [
    'level',
    'fields',
    'group',
  ],
  data () {
    return {
      locale: window.Translator.locale,
      drag: false,
      openFields: [],
      fontThemes: window.config.fontStyles.map((style, index) => { return { value: (index + 1).toString(), label: style.label } }),
      dataLevel: this.level,
      dataFields: this.fields
    }
  },
  methods: {
    fieldSwitchLabel (fieldProfileInstance, value) {
      ZoneProfileInstanceAPI.updateField(fieldProfileInstance.id, {showLabel: value})
    },
    fieldCheckboxEnabled (fieldProfileInstance, value) {
      ZoneProfileInstanceAPI.updateField(fieldProfileInstance.id, {isEnabled: value})
    },
    zoneSwitchFont(fieldProfileInstance, value) {
      ZoneProfileInstanceAPI.updateField(fieldProfileInstance.id, {fontClass: value})
    },
    zoneSwitchBulletPoint(fieldProfileInstance, value) {
      ZoneProfileInstanceAPI.updateField(fieldProfileInstance.id, {bulletPoint: value})
    },
    zoneSwitchTopSpacing(fieldProfileInstance, value) {
      ZoneProfileInstanceAPI.updateField(fieldProfileInstance.id, {topSpacing: value})
    },
    zoneSwitchBottomSpacing(fieldProfileInstance, value) {
      ZoneProfileInstanceAPI.updateField(fieldProfileInstance.id, {bottomSpacing: value})
    },
    zoneSwitchMergeContent(fieldProfileInstance, value) {
      ZoneProfileInstanceAPI.updateField(fieldProfileInstance.id, {mergeContent: value})
    },
    openClose (fieldId) {
      if(this.openFields.indexOf(fieldId) === -1){
        this.openFields.push(fieldId)
      }
      else{
        this.openFields = helper.arrayRemove(this.openFields, fieldId)
      }
    },
    onDrag () {
      let positions = []
      this.dataFields.forEach((field, index) => {
        positions.push({
          id: field.id,
          position: index
        })
      })
      PositionsAPI.updates('field-profile-instances', positions)
    },
    isOpen (fieldId) {
      return (this.openFields.indexOf(fieldId) !== -1)
    },
    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  },
  computed: {
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  }
}
</script>
